const initialState = {
  fetchedBand: [],
  fetchedBandAlbums: []
}

const bandReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_FETCHED_ARTIS':
      return {
        ...state,
        fetchedBand: state.fetchedBand.concat(action.payload)
      }
    case 'ADD_FETCHED_ARTIS_ALBUM':
      return {
        ...state,
        fetchedBandAlbums: state.fetchedBandAlbums.concat(action.payload)
      }
    case 'SET_EMPTY_FETCHED_ARTIS':
      return {
        ...state,
        fetchedBand: []
      }
    case 'SET_EMPTY_FETCHED_ARTIS_ALBUM':
      return {
        ...state,
        fetchedBandAlbums: []
      }
    default:
      return state
  }
}

export default bandReducer
